import { render, staticRenderFns } from "./ControllerBannerDescription.vue?vue&type=template&id=3f012df4&"
import script from "./ControllerBannerDescription.vue?vue&type=script&lang=ts&"
export * from "./ControllerBannerDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports